import { useEffect } from 'react';
import Routers from './Routes';
import { BrowserRouter } from 'react-router-dom';
import '../src/css/App.css';
import '../src/css/letter.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {	
    useEffect(()=>{
      document.title = "Data Aces - Employee App";    
    },[])
    
    return (
    <BrowserRouter>
       <ToastContainer 
           position="top-right" 
           autoClose={2500}
           hideProgressBar={true}
           closeOnClick={true}
           pauseOnHover={false}
           draggable={false}
           newestOnTop={true}
           theme="light"
           toastStyle={{ fontSize: '13px', minHeight: '40px', padding: '8px 12px' }} 
       />
    	  <Routers />
    </BrowserRouter>
  );
}

export default App;
